import {
  createBrowserRouter,
  createHashRouter
} from "react-router-dom";

import MainLayout
  from "../layouts/MainLayout";

import ProtectedRoute
  from "./ProtectedRoute";

import LoginPage
  from "../pages/login/Login";

import FichasPage
  from "../pages/fichas/ListPage";

import LiderancasPage
  from "../pages/liderancas/ListPage";

import ZonasPage
  from "../pages/zonas/ListPage";

import SessoesPage
  from "../pages/sessoes/ListPage";

import ProfissionaisPage
  from "../pages/profissionais/ListPage";

import ProcedimentosPage
  from "../pages/procedimentos/ListPage";

import AgendamentosPage
  from "../pages/agendamentos/ListPage";

export const router =
  createHashRouter([

    {
      path: "/login",
      element: <LoginPage />
    },

    {
      path: "/",
      element: (

        <ProtectedRoute>

          <MainLayout />

        </ProtectedRoute>
      ),

      children: [

        {
          index: true,
          element: <FichasPage />
        },

        {
          path: "fichas",
          element: <FichasPage />
        },

        {
          path: "liderancas",
          element: <LiderancasPage />
        },

        {
          path: "zonas",
          element: <ZonasPage />
        },

        {
          path: "sessoes",
          element: <SessoesPage />
        },

        {
          path: "profissionais",
          element: <ProfissionaisPage />
        },

        {
          path: "procedimentos",
          element: <ProcedimentosPage />
        },

        {
          path: "agendamentos",
          element: <AgendamentosPage />
        }
      ]
    }
  ]);